export const ACCESSIBILITY_AUDIT_READ_ROLE = 'AskIAM.Accessibility.Audit.Read';

export const isAccessibilityAuditor = (roles: string[]): boolean =>
  roles.includes(ACCESSIBILITY_AUDIT_READ_ROLE);

export const isAccessibilityAuditSession = (
  user: { roles: string[]; accessibilityAuditSession?: boolean } | null | undefined,
): boolean => user?.accessibilityAuditSession === true || isAccessibilityAuditor(user?.roles ?? []);
